module.exports = __webpack_public_path__ + "static/media/Template-image-Menu-item-v1-01.23e6cd6c.png";